import styled from 'styled-components';
import Div from './Div';

const Grid = styled(Div)`
    display:grid;
    gap: ${props => props.gap};
    align-items: ${props => props.alignItems};
`;

export default Grid;